module.exports = __webpack_public_path__ + "img/orange-and-red-lily.717e0fa6.jpg";